import * as React from 'react';

const DoubleArrowIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={props.stroke || '#8A94F8'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m13 8 4 4-4 4M7 8l4 4-4 4"
    ></path>
  </svg>
);

export default DoubleArrowIcon;
